<template>
  <logged-in-layout :hasNav="false">
    <main>
      <component :is="softphoneComponent" :isGhost="false" />

      <with-pusher-subscription :class="$style.content">
        <network-change-detector />
        <dialpad v-if="hasDialpad" />
        <notepad />
        <live-coach-chat />

        <div v-show="showCallScreen" :class="$style.callScreen">
          <contact-info />
          <call-status />
          <call-duration />
          <recording-indicator />
          <toolbar v-if="callStatus !== 'completed'" />
          <end-call-button :class="$style.endCallButton" />
          <RecordingMessage v-if="activity.recordingReasonCode" :reason="activity.recordingReasonCode" />
        </div>
      </with-pusher-subscription>
    </main>
  </logged-in-layout>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import WithPusherSubscription from './with-pusher-subscription/with-pusher-subscription'
  import NetworkChangeDetector from './network-change-detector/network-change-detector'
  import Dialpad from './dialpad/dialpad'
  import Notepad from './notepad/notepad'
  import LiveCoachChat from './live-coach-chat/live-coach-chat'
  import CallDuration from './call-duration/call-duration'
  import CallStatus from './call-status/call-status'
  import ContactInfo from './contact-info/contact-info'
  import RecordingIndicator from './recording-indicator/recording-indicator'
  import Toolbar from './toolbar/toolbar'
  import EndCallButton from './end-call-button/end-call-button'
  import TwilioSoftphone from './twilio-softphone/twilio-softphone'
  import JiminnySoftphone from './jiminny-softphone/jiminny-softphone'
  import RecordingMessage from './RecordingMessage/RecordingMessage'
  import EventBus from '@/lib/event-bus'
  import notyMixin from '@/helpers/noty'

  import { activeCallPresentNotification } from './notifications'

  const { mapState, mapGetters, mapActions } = createNamespacedHelpers('conference')

  export default {
    mixins: [
      notyMixin
    ],
    components: {
      LoggedInLayout,
      WithPusherSubscription,
      NetworkChangeDetector,
      Dialpad,
      Notepad,
      LiveCoachChat,
      CallDuration,
      CallStatus,
      ContactInfo,
      RecordingIndicator,
      Toolbar,
      EndCallButton,
      RecordingMessage
    },
    computed: {
      ...mapState([
        'activity',
        'dialpadVisible',
        'notepadVisible',
        'liveCoachChatVisible'
      ]),
      ...mapGetters([
        'connectionType',
        'hasDialpad',
        'callStatus'
      ]),
      softphoneComponent () {
        return this.connectionType === 'web-rtc'
          ? TwilioSoftphone
          : JiminnySoftphone
      },
      showCallScreen () {
        if (this.notepadVisible || this.dialpadVisible || this.liveCoachChatVisible) {
          return false
        }

        return true
      }
    },
    beforeRouteLeave (to, from, next) {
      const allowedRoutesToFollow = [
        '/activity-summary',
        '/contacts',
        '/error-page'
      ]

      if (allowedRoutesToFollow.includes(to.path)) {
        next()
      } else {
        next(false)
        this.$_notificationsToCloseOnDestroy.push(
          activeCallPresentNotification().show()
        )
      }
    },
    created () {
      if (!this.activity) {
        // Render home screen if user hit the back button on activity summary page
        this.$router.push({path: '/contacts'})
      }
    },
    beforeDestroy () {
      this.resetState()
    },
    mounted () {
      EventBus.$emit('JOIN_CONFERENCE_CALL')
    },
    methods: mapActions([
      'resetState'
    ])
  }
</script>

<style module lang="less" src="./rep-call.less"></style>



// WEBPACK FOOTER //
// rep-call.vue?619c5da2